import React from 'react';
import StatusLabel from '../../../VentoryUI/components/common/StatusLabel/StatusLabel';
import { AssetTransaction } from '../../../types/asset_transaction/assetTransaction';
import { AssetTransactionUtil } from '../../../types/asset_transaction/assetTransaction.util';
import { translate } from '../../../types/translation/Translator';

interface AssetTransactionStatusLabelProps {
  asset: AssetTransaction;
}

export default function AssetTransactionStatusLabel({ asset }: AssetTransactionStatusLabelProps) {
  return (
    <StatusLabel
      color={AssetTransactionUtil.statusToColorStyle(asset)}
      text={translate({ key: AssetTransactionUtil.transactionToDetailedStatus(asset) })}
    />
  );
}
